<template>
  <div>
    <a-button type="primary" style="margin:0 10px" @click="ExportReport(1)"
      >导出五联单年及月度汇总表</a-button
    >
    <a-button type="primary" style="margin:0 10px" @click="ExportReport(2)"
      >导出五联单日汇总表(按区域汇总)</a-button
    >
    <a-button type="primary" style="margin:0 10px" @click="ExportReport(3)"
      >导出医疗废物处置月汇总表(按医疗机构汇总)</a-button
    >
    <a-button type="primary" style="margin:0 10px" @click="ExportReport(4)"
      >导出医疗废物处置日表(按医疗机构)</a-button
    >
    <a-button type="primary" style="margin:0 10px" @click="ExportReport(5)"
      >导出医疗废物处置日表(按县、医疗机构导出)</a-button
    >
    <a-button type="primary" style="margin:0 10px" @click="ExportReport(6)"
      >导出医疗废物处置日汇总表(按医疗机构汇总)</a-button
    >
    <a-modal
      :visible="visible"
      title="导出"
      @cancel="cancel"
      width="800px"
      @ok="handleOk"
    >
      <template slot="footer">
        <a-button @click="cancel">
          取消
        </a-button>
        <a-button type="primary" :loading="loading" @click="handleOk">
          确定
        </a-button>
      </template>
      <a-form-model
        :rules="rules"
        ref="ruleForm"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="统计年" prop="Year">
          <a-input v-model="form.Year" placeholder="请输入年份" />
        </a-form-model-item>
        <a-form-model-item label="统计月" prop="Month" v-if="CntType != 1">
          <a-input v-model="form.Month" placeholder="请输入统计月" />
        </a-form-model-item>
        <a-form-model-item label="统计日" prop="Day" v-if="CntType == 6">
          <a-input v-model="form.Day" placeholder="请输入统计月" />
        </a-form-model-item>
        <a-form-model-item label="统计城市区域" v-if="CntType == 3 || CntType == 5|| CntType == 6">
          <!-- <a-input v-model="form.City" placeholder="请输入统计城市区域" /> -->
        <a-select
            show-search
            placeholder="请选择统计城市区域"
            option-filter-prop="children"
            style="width: 200px"
            v-model="form.City"
          >
            <a-select-option :value="item" v-for="(item,i) of addressList" :key="i">
              {{item}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="统计组织机构"
          prop="OrgName"
          v-if="CntType == 4"
        >
          <!-- <a-input v-model="form.OrgName" placeholder="请输入统计组织机构" /> -->
           <a-select
            show-search
            placeholder="请选择统计组织机构"
            option-filter-prop="children"
            style="width: 200px"
            v-model="form.OrgName"
          >
            <a-select-option :value="item" v-for="(item,i) of nameList" :key="i">
              {{item}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {ExportReport} from './js/ApiQuery'
import {getOrgQueryList} from '../basic/js/ApiBasic';

export default {
  data() {
    return {
      CntType: "",
      visible: false, //false,
      loading: false,
      form: {
        Year: new Date().getFullYear(),
        Month: new Date().getMonth() + 1,
        City: "",
        OrgId: "",
        Day:new Date().getDate()
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      rules: {
        Year: [{ required: true, message: "请输入...", trigger: "blur" }],
        Month: [{ required: true, message: "请输入...", trigger: "blur" }],
        OrgName: [{ required: true, message: "请输入...", trigger: "blur" }],
        Day: [{ required: true, message: "请输入...", trigger: "blur" }],
      },
      nameList:[],
      addressList:[]
    };
  },
  mounted(){
      this.getOrgQueryList()
  },
  methods: {
    ExportReport(Type) {
      this.CntType = Type;
      this.visible = true;
    },
    cancel() {
      this.visible = false;
      this.CntType = "";
      this.$refs.ruleForm.resetFields();
      this.form = {
        Year: new Date().getFullYear(),
        Month: new Date().getMonth() + 1,
        City: "",
        OrgName: "",
        Day:new Date().getDate()
      };
    },
    getOrgQueryList(){
            let baseDto = {
                  pageIndex: 1,
                  pageSize: 99999,
            };
            getOrgQueryList({baseDto: baseDto}).then(res => {
                // this.data = res.data;
                var addressArr = []
                res.data.data.forEach(item => {
                    this.nameList.push(item.name)
                     addressArr.push(item.address)
                });
                this.addressList = this.unique(addressArr)
            })
    },
    unique(arr) {
        var newArr = [];
        for (var i = 0; i < arr.length; i++) {
            if (newArr.indexOf(arr[i]) === -1) {
                newArr.push(arr[i]);
            }
        }
        return newArr;
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
        //   alert("submit!");
        this.loading = true
        let data = {}
        if (this.CntType == 1) {
             data = {
                CntType:this.CntType,
                Year:this.form.Year
            }
        }else if (this.CntType == 2) {
            data = {
                CntType:this.CntType,
                Year:this.form.Year,
                Month:this.form.Month,
            }
        }else if (this.CntType == 3) {
            data = {
                CntType:this.CntType,
                Year:this.form.Year,
                Month:this.form.Month,
                City:this.form.City
            }
        }else if (this.CntType == 4) {
            data = {
                CntType:this.CntType,
                Year:this.form.Year,
                Month:this.form.Month,
                OrgName :this.form.OrgName ,
            }
        }else if (this.CntType == 5) {
            data = {
                CntType:this.CntType,
                Year:this.form.Year,
                Month:this.form.Month,
                City:this.form.City
            }
        }else if (this.CntType == 6) {
            data = {
                CntType:7,
                Year:this.form.Year,
                Month:this.form.Month,
                City:this.form.City,
                Day:this.form.Day
            }
        }
        ExportReport(data).then(res=>{
            console.log(res);
            var url = 'http://49.4.66.163:8000/api/FileUpload/file?url=' + res.data
            window.open(url, '_blank')
            this.visible = false

        })
        this.loading = false
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style></style>
